<script setup lang="ts">
import type { DirectSaleItemEntityWithPrice } from '~/types/directSale.type';

// PROPS
const { directSale } = defineProps({
    directSale: { type: Object as PropType<DirectSaleItemEntityWithPrice>, required: true },
    loading: { type: Boolean, default: false },
});

// COMPOSABLES
const { tt, tn } = useTypedI18n();
const { isMobile } = useResponsive();
const { trackDsdpOrderModalConfirm } = useTracking();

// MODEL
const isModalOpen = defineModel<boolean>({ required: true });

// EMITS
const emit = defineEmits<{
    confirm: [];
}>();

// METHODS
const onConfirm = (): void => {
    trackDsdpOrderModalConfirm();
    emit('confirm');
};
</script>

<template>
    <UModal v-model:open="isModalOpen" :fullscreen="isMobile" :title="tt('sdp.DirectSale.order.title')" v-bind="modalNoDescAriaFixupProps">
        <template #body>
            <div class="flex flex-col gap-6 text-center">
                <p class="text-sm md:text-base">
                    {{ tt('sdp.DirectSale.order.description') }}
                </p>
                <div class="bg-primary-50 flex flex-col items-center gap-3 rounded-xl p-6">
                    <p class="text-xs font-extrabold tracking-widest uppercase">
                        {{ tt('sdp.DirectSale.order.price') }}
                    </p>
                    <p class="text-primary text-3xl">{{ tn(directSale.price, 'currency') }}</p>

                    <SaleFees
                        :base-amount="directSale.price"
                        :assets-count="directSale.assets.length"
                        :fee-configuration="directSale.userMeta?.feeOverride"
                        is-buyer
                    />
                </div>
            </div>
        </template>

        <template #footer="{ close }">
            <UButton size="xl" :label="tt('sdp.DirectSale.order.button')" block :loading="loading" @click="onConfirm" />
            <UButton size="xl" block color="neutral" variant="link" :label="tt(`sdp.DirectSale.order.cancel`)" @click="close" />
        </template>
    </UModal>
</template>
